import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const LivePriceTicker = () => {
  const [prices, setPrices] = useState([
    {
      id: 1,
      market: 'Pune APMC',
      commodity: 'White Sugar M30',
      price: 3850,
      change: 2.3,
      volume: '1,250 MT',
      trend: 'up'
    },
    {
      id: 2,
      market: 'Mumbai Market',
      commodity: 'Raw Sugar S30',
      price: 3620,
      change: -1.2,
      volume: '890 MT',
      trend: 'down'
    },
    {
      id: 3,
      market: 'Kolhapur Zone',
      commodity: 'Premium Sugar',
      price: 4100,
      change: 0.8,
      volume: '650 MT',
      trend: 'up'
    },
    {
      id: 4,
      market: 'Delhi NCR',
      commodity: 'White Sugar M30',
      price: 3920,
      change: 1.5,
      volume: '1,100 MT',
      trend: 'up'
    },
    {
      id: 5,
      market: 'Bangalore Market',
      commodity: 'Refined Sugar',
      price: 3780,
      change: -0.5,
      volume: '720 MT',
      trend: 'down'
    }
  ]);

  // Simulate live price updates
  useEffect(() => {
    const interval = setInterval(() => {
      setPrices((currentPrices) =>
        currentPrices?.map((price) => ({
          ...price,
          price: price?.price + (Math.random() - 0.5) * 10,
          change: parseFloat((Math.random() * 4 - 2)?.toFixed(2)),
          trend: Math.random() > 0.5 ? 'up' : 'down'
        }))
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden mb-6">
      <div className="bg-primary/10 border-b border-border px-4 py-3">
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Live Market Prices</h2>
          <span className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
            <span className="inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            Live Updates
          </span>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="flex animate-scroll hover:pause-animation">
          {[...prices, ...prices]?.map((price, index) => (
            <div
              key={`${price?.id}-${index}`}
              className="flex-shrink-0 px-6 py-4 border-r border-border last:border-r-0 min-w-[280px]"
            >
              <div className="space-y-2">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-semibold text-foreground text-sm">{price?.market}</h3>
                    <p className="text-xs text-muted-foreground">{price?.commodity}</p>
                  </div>
                  <Icon
                    name={price?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
                    size={16}
                    className={price?.trend === 'up' ? 'text-green-500' : 'text-red-500'}
                  />
                </div>
                
                <div className="flex items-end justify-between">
                  <div>
                    <div className="text-2xl font-bold text-foreground">
                      ₹{price?.price?.toFixed(0)}
                    </div>
                    <div className="text-xs text-muted-foreground">per quintal</div>
                  </div>
                  
                  <div className={`flex items-center gap-1 text-sm font-medium ${
                    price?.change >= 0 ? 'text-green-500' : 'text-red-500'
                  }`}>
                    <Icon name={price?.change >= 0 ? 'ArrowUp' : 'ArrowDown'} size={14} />
                    <span>{Math.abs(price?.change)}%</span>
                  </div>
                </div>
                
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>Volume</span>
                  <span className="font-medium">{price?.volume}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LivePriceTicker;